'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _JacketCover = require('./components/JacketCover.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_JacketCover).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/jacket-cover/lib/index.js
// module id = 485
// module chunks = 0 3 4 9